/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

// OTP_AUTH_TOKEN_MOBILE_KEY must match changeUserName's literal in hooks/account.ts (guard test).
export const OTP_AUTH_TOKEN_EMAIL_KEY = 'otp_auth_token_email';
export const OTP_AUTH_TOKEN_MOBILE_KEY = 'otp_auth_token_mobile';
